import React from 'react';
import { Box } from '@mui/material';
import { tableHeaderCellStyles } from '../../../ExitRequestResponseUnified/ExitRequestResponseStyles';
import { COLUMN_CONFIG, UI_CONSTANTS } from './AffectedProductsTab.constants';

export const ProductTableHeader = ({ theme }) => (
    <Box sx={styles.headerContainer(theme)}>
        {Object.entries(COLUMN_CONFIG).map(([key, config]) => (
            <Box
                key={key}
                sx={{
                    ...tableHeaderCellStyles(theme),
                    flex: config.flex,
                    fontSize: UI_CONSTANTS.FONT_SIZES.HEADER
                }}
            >
                {config.label}
            </Box>
        ))}
    </Box>
);

const styles = {
    headerContainer: (theme) => ({
        display: 'flex',
        width: '100%',
        backgroundColor: theme.palette.grey[100],
        borderBottom: `1px solid ${theme.palette.divider}`,
        zIndex: 10,
        position: 'sticky',
        top: 0,
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    })
};